export const smartDecodeURIComponent = (str) => {
  if (!str) return str;

  let result = str;
  let prevResult = '';
  let iterations = 0;
  const maxIterations = 10; // Защита от бесконечного цикла

  // Продолжаем декодировать, пока строка меняется и не достигнут лимит итераций
  while (result !== prevResult && iterations < maxIterations) {
    try {
      prevResult = result;
      result = decodeURIComponent(result);
      iterations++;

      // Проверяем, является ли результат валидным JSON
      try {
        JSON.parse(result);
        // Если удалось распарсить JSON, значит декодирование завершено
        break;
      } catch {
        // Если не удалось распарсить JSON, продолжаем декодирование
        continue;
      }
    } catch (e) {
      // Если произошла ошибка декодирования, возвращаем последний успешный результат
      return prevResult;
    }
  }

  return result;
};

// Query keys that carry one-time OAuth secrets: the SP claim token, the Ads OAuth session id,
// the eBay, Shopify, Google, TikTok, Pinterest, Meta and Bing claim tokens and the raw authorization code / state (Amazon's, TikTok's auth_code). None of them
// may leave the browser in an analytics page path or an error report.
export const SENSITIVE_QUERY_KEYS = [
  'sp_session',
  'sessionId',
  'ebayClaim',
  'shopifyClaim',
  'googleClaim',
  'tiktokClaim',
  'pinterestClaim',
  'metaClaim',
  'bingClaim',
  'code',
  'state',
  'spapi_oauth_code',
  'auth_code',
];

const sensitiveKeys = new Set(SENSITIVE_QUERY_KEYS.map((key) => key.toLowerCase()));

// Drops SENSITIVE_QUERY_KEYS from a 'k=v&…' string, recursing into values that are themselves
// URLs. Returns the rebuilt string, or null when nothing was removed.
const redactParams = (params) => {
  let changed = false;
  const kept = [];
  for (const [key, value] of new URLSearchParams(params)) {
    if (sensitiveKeys.has(key.toLowerCase())) {
      changed = true;
      continue;
    }
    const redacted = /[?#]/.test(value) ? redactSensitiveQuery(value) : value;
    if (redacted !== value) changed = true;
    kept.push([key, redacted]);
  }

  return changed ? new URLSearchParams(kept).toString() : null;
};

// Drops SENSITIVE_QUERY_KEYS from a path or absolute URL, keeping everything else. A value that
// is itself a URL with a query or hash — the login round-trip's
// ?to=/integrations/sp/connected?sp_session=… — is redacted too, and so is a fragment in 'k=v'
// form (the Shopify handoff's #shopifyClaim=…); any other hash is kept as is. Returns the input
// unchanged when nothing was removed.
export const redactSensitiveQuery = (url) => {
  if (typeof url !== 'string') return url;

  const hashStart = url.indexOf('#');
  const beforeHash = hashStart === -1 ? url : url.slice(0, hashStart);
  const hash = hashStart === -1 ? null : url.slice(hashStart + 1);
  const queryStart = beforeHash.indexOf('?');
  const path = queryStart === -1 ? beforeHash : beforeHash.slice(0, queryStart);
  const query = queryStart === -1 ? null : beforeHash.slice(queryStart + 1);

  const redactedQuery = query === null ? null : redactParams(query);
  const redactedHash = hash !== null && hash.includes('=') ? redactParams(hash) : null;
  if (redactedQuery === null && redactedHash === null) return url;

  const finalQuery = redactedQuery ?? query;
  const finalHash = redactedHash ?? hash;

  return `${path}${finalQuery ? `?${finalQuery}` : ''}${finalHash ? `#${finalHash}` : ''}`;
};
